import { useAdminApi } from '@components/providers/AdminApiProvider';
import { Button } from '@my-medication/shared-components/ui/Button';
import { Dialog, DialogTypes } from '@my-medication/shared-components/ui/Dialog';
import { GeneralKeys, Namespace } from '@i18n/translations';
import { useAdminStore } from '@store/adminStore';
import { type FunctionComponent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { type AdminSessionInvalidDialogProps } from './AdminSessionInvalidDialog.types';

const AdminSessionInvalidDialog: FunctionComponent<AdminSessionInvalidDialogProps> = ({
  dataTestid = 'admin-session-invalid-dialog',
}) => {
  const { t } = useTranslation(Namespace.General);
  const { server } = useAdminApi();
  const sessionInvalid = useAdminStore((s) => s.user.sessionInvalid);
  const setSessionInvalid = useAdminStore((s) => s.setSessionInvalid);
  const [reloading, setReloading] = useState(false);

  const handleReload = useCallback(async () => {
    setReloading(true);

    try {
      await server.refreshSelf();
      setSessionInvalid(false);
    } catch {
      window.location.reload();
    } finally {
      setReloading(false);
    }
  }, [server, setSessionInvalid]);

  return (
    <Dialog
      dataTestid={dataTestid}
      id="adminSessionInvalid"
      open={sessionInvalid}
      onlyClosableViaButtons
      type={DialogTypes.info}
      title={t(GeneralKeys.Notifications_SessionInvalidText)}
      hideTitle
      showCloseButton={false}
      description={t(GeneralKeys.Notifications_SessionInvalidText)}
      footer={
        <Button name="session-invalid-reload" variant="modal-primary" loading={reloading} onClick={handleReload}>
          {t(GeneralKeys.ReloadPage)}
        </Button>
      }
    />
  );
};

AdminSessionInvalidDialog.displayName = 'AdminSessionInvalidDialog';

export { AdminSessionInvalidDialog };
